import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();

  if (!user) {
    // Not logged in, redirect to login page
    return <Navigate to="/login" />;
  }

  if (adminOnly && !user.isAdmin) {
    // User is logged in but not an admin, redirect to dashboard
    return <Navigate to="/" />;
  }

  // Authorized, render component
  return children;
};

export default ProtectedRoute;
